import { Grey } from '../constants';

const fullBarWidth = 177;
const barHeight = 4;
const separatorPosition = 88;
const separatorWidth = 1;
const borderRadius = 2;

const green = '#41A512';
const yellow = '#FFB900';
const red = '#A80001';

// [0, 0.4] => green, (0.4, 0.8] => yellow, 0.8+ => red
const getColor = (percentage) => {
  if (percentage <= 0.4) return green;
  if (percentage <= 0.8) return yellow;
  return red;
};

export const getTotalBudgetDepletedProgressBarStyles = () => ({
  Container: {
    position: 'relative',
    width: fullBarWidth,
    height: barHeight,
  },
  Bar: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    background: ({ percentage }) => {
      const progress = 50 * percentage;
      const color = getColor(percentage);

      return `linear-gradient(to right, ${color} ${progress}%, ${Grey} ${progress}%)`;
    },
    borderRadius,
  },
  Separator: {
    position: 'absolute',
    width: separatorWidth,
    height: '100%',
    left: separatorPosition,
    backgroundColor: Grey,
  },
});
